class DeleteAssessmentCredentialModalController {
    constructor() {
        // this.companyId = this.resolve.companyId;
        // this.buId = this.resolve.buId;
        // this.testOwnerEmail = this.resolve.testOwnerEmail;
        // this.assessmentId = this.resolve.assessmentId;
        // this.context = this.resolve.context;
        // this.isDeleteCredential = this.resolve.isDeleteCredential;
    }
    $onInit() {
        this.companyId = this.resolve.companyId;
        this.buId = this.resolve.buId;
        this.testOwnerEmail = this.resolve.testOwnerEmail;
        this.assessmentId = this.resolve.assessmentId;
        this.context = this.resolve.context;
        this.isDeleteCredential = this.resolve.isDeleteCredential;
        this.title = this.isDeleteCredential ? 'Assessment Credential Deletion' : 'Remove Assessment';
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    }
    delete() {
        this.callbackObject.callbackType = 'delete';
        this.closeModal();
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
}
// import * as TEMPLATE from './delete-assessment-credential-modal.html';
import * as TEMPLATE from 'raw-loader!./delete-assessment-credential-modal.html';
export const DeleteAssessmentCredentialModalComponent = {
    selector: 'deleteAssessmentCredentialModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: DeleteAssessmentCredentialModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/deleteAssessmentCredentialModal/delete-assessment-credential-modal.html'
    }
};
//# sourceMappingURL=delete-assessment-credential-modal.component.js.map